import { isPrivateClientStrategyAlias } from "../../utils/proposalUtils";

const ELIGIBLE_EXISTING_ACTIONS = new Set([
  "Strategy Change",
  "Risk Tolerance Update",
  "Fee Update",
]);

export const supportsPcsRegistrationType = (
  requestType,
  existingRequestAction,
) =>
  requestType === "New" ||
  (requestType === "Existing" &&
    ELIGIBLE_EXISTING_ACTIONS.has(existingRequestAction));

export const isPcsRegistrationStrategy = (
  strategy,
  proposalTypes = [],
) => isPrivateClientStrategyAlias(strategy, proposalTypes);

export const isPcsMultiRegistrationState = (
  state = {},
  proposalTypes = [],
) =>
  supportsPcsRegistrationType(
    state.requestType,
    state.existingRequestAction,
  ) &&
  isPcsRegistrationStrategy(state.strategy, proposalTypes) &&
  state.pcsRegistrationType === "Multi";

export const normalizePcsRegistrationRows = (registrations = []) =>
  (Array.isArray(registrations) ? registrations : []).map(
    (registration, index) => ({
      ...registration,
      registration: `registration${index}`,
      accountOwner: String(registration?.accountOwner || ""),
      value: String(
        registration?.value || registration?.registrationName || "",
      ),
      percentage: "100",
    }),
  );

export const arePcsRegistrationRowsComplete = (registrations = []) =>
  Array.isArray(registrations) &&
  registrations.length > 0 &&
  registrations.every(
    (registration) =>
      !!String(registration?.accountOwner || "").trim() &&
      !!String(registration?.value || "").trim(),
  );

export const buildPcsRegistrationPayload = (registrations = []) =>
  normalizePcsRegistrationRows(registrations).map((registration) => ({
    accountOwner: registration.accountOwner.trim(),
    registration: registration.value.trim(),
  }));
